import React from 'react';
import { Button, HSpacer, Text, VSpacer } from '@/components/DesignSystem';
import { Box, Stack, useTheme } from '@mui/material';
import ViewMember from './ViewMember';
import { RetailerEndpoint } from '@api/endpoints';
import AddIcon from '@mui/icons-material/Add';
import { stringifyCount } from "@/constants/HierarchyOfRetailers";
import MemberFormModal from '@/pages/Admin/HierarchyOfRetailers/Members/MemberFormModal';

type MemberOverviewSectionProps = {
  isLocation?: boolean;
  members: RetailerEndpoint.MemberList.Response | undefined;
  onAddMember: () => void;
  onViewMember: () => void;
  search: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  showAddMember: boolean;
  showViewMember: boolean;
};

const MemberOverviewSection = ({
  isLocation = false,
  members,
  onAddMember,
  onViewMember,
  search,
  setSearch,
  showAddMember,
  showViewMember,
}: MemberOverviewSectionProps) => {
  const theme = useTheme();

  return (
    <Stack
      alignItems={'center'}
      direction='row'
      justifyContent='space-between'
      sx={{
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: '12px 20px',
      }}
    >
      <Stack>
        <Text category="title-small">Members</Text>
        <VSpacer size="1" />
        <Text category="body-medium" sx={{ color: theme.palette.text.secondary }}>
          {stringifyCount(members?.total, 'member', 'members')}
        </Text>
      </Stack>
      <Box>
        <Button
          disabled={!members?.total}
          onClick={onViewMember}
          testID='view-members'
          variant="outlined"
        >
          View Members
        </Button>
        <HSpacer size='4' />
        <Button
          onClick={onAddMember}
          startIcon={<AddIcon />}
          testID='view-member'
          variant="outlined"
        >
          Add Member
        </Button>
      </Box>
      {showAddMember && (
        <MemberFormModal
          isLocation={isLocation}
          onClose={onAddMember}
          show={showAddMember}
        />
      )}
      {showViewMember && (
        <ViewMember
          isLocation={isLocation}
          members={members}
          onClose={onViewMember}
          search={search}
          setSearch={setSearch}
          show={showViewMember}
        />
      )}
    </Stack>
  );
};

export default MemberOverviewSection;
